module.exports = __webpack_public_path__ + "img/3.c97a9d22.png";